import React, { Component } from 'react';
import { BrowserRouter as Router,  Routes, Route} from "react-router-dom";
import './Initial/config.js';
import Footer from './Initial/Footer.js';
import NavBar from './Menu.js';
import Error404 from './Initial/Error404.js';
import Home from './Initial/Home.js';
import Wmais from './Initial/wmais.js';
import NewId from './Initial/wmaisId';
import Campanhas from './Initial/campanhas.js';
import CampanhasId from './Initial/campanhasId.js';
import Restaurantes from './Initial/Restaurantes';
import Academia from './Initial/Academia';
import Faculdades from './Initial/Faculdades';
import Outros from './Initial/Otros';
import Politicasti from './Initial/Politicas_ti';
import Politicasadmin from './Initial/Politicas_admin';
import Politicasfinan from './Initial/Politicas_finan';
import Politicasrh from './Initial/Politicas_rh';
import ProcedimentosTI from './Initial/Procedimientos_ti';
import ProcedimentosRH from './Initial/Procedimientos_rh';
import ProcedimentosAdmin from './Initial/Procedimientos_admin';
import ProcedimentosFinan from './Initial/Procedimientos_finan';
import ComunicacionCorp from './Initial/comunicacionCorp';
import Capacitaciones from './Initial/Capacitaciones.js';
import Beneficios from './Initial/Beneficios';
import Saude from './Initial/Saude.js';
import Calendario from './Initial/Calendario.js';
import IdentidadeVisual from './Initial/IdentidadeVisual.js';
import LogosClientes from './Initial/LogosClientes.js';
import Presentaciones from './Initial/Presentaciones.js';
import Cases from './Initial/Cases.js';
import Vida from './Initial/Vida.js';
import Entendam from './Initial/EntendamCadaUma.js';
import Diversidad from './Initial/diversidad.js';
import DiversidadId from './Initial/diversidadId.js';
import ProcedimientosIpg  from './Initial/Procedimientos_ipg.js';
import DayOff from './Initial/DayOff.js';
import FinanzasFAQ from './Initial/FAQ_finanzas';
import SuporteFAQ from './Initial/FAQ_suporte';
import SkillsFAQ from './Initial/FAQ_skills';
import AdsolutionsFAQ from './Initial/FAQ_adsolutions';
class App extends Component {
  render() {
    return (
      <Router>
        <NavBar/>
            <Routes>
              <Route exact path="/" element={<Home/>} />
              <Route path="/comunicacao-interna" element={<Wmais/>} />
              <Route path="/comunicacao-interna/:id" element={<NewId/>} />
                            <Route path="/comunicacao-externa" element={<Campanhas/>} />
                            <Route path="/comunicacao-externa/:id" element={<CampanhasId/>} />
                            <Route path="/identidade-visual" element={<IdentidadeVisual/>} />
                            <Route path="/logos-clientes" element={<LogosClientes/>} />
                            <Route path="/presentaciones" element={<Presentaciones/>} />
                            <Route path="/cases" element={<Cases/>} />
                            <Route path="/saude" element={<Beneficios/>} />
                            <Route path="/vida" element={<Vida/>} />
                            <Route path="/restaurantes" element={<Restaurantes/>} />
                            <Route path="/convenios-academia" element={<Academia/>} />
                            <Route path="/educacion" element={<Faculdades/>} />
                            <Route path="/day-off" element={<DayOff/>} /> 
                            <Route path="/parcerias" element={<Outros/>} />
                            <Route path="/politicas-rh" element={<Politicasrh/>} />
                            <Route path="/politicas-ti" element={<Politicasti/>} />
                            <Route path="/politicas-administrativo" element={<Politicasadmin/>} />
                            <Route path="/politicas-financeiro" element={<Politicasfinan/>} />
                            <Route path="/procedimientos-rh" element={<ProcedimentosRH/>} />
                            <Route path="/procedimientos-ti" element={<ProcedimentosTI/>} />
                            <Route path="/procedimientos-financeiro" element={<ProcedimentosFinan/>} />
                            <Route path="/procedimientos-administrativo" element={<ProcedimentosAdmin/>} />
                            <Route path="/faq_financeiro" element={<FinanzasFAQ/>} />
                            <Route path="/ipg" element={<ProcedimientosIpg/>} />
                            <Route path="/c-corporativa" element={<comunicacionCorp/>} />
                            <Route path="/saude-seguran" element={<Saude/>} />
                            <Route path="/pessoas-treinamento" element={<Capacitaciones/>} />
                            <Route path="/entendam-cada-uma" element={<Entendam/>} />
                            <Route path="/faq_suporte" element={<SuporteFAQ/>} />
                            <Route path="/faq_skills" element={<SkillsFAQ/>} />
                            <Route path="/faq_adsolutions" element={<AdsolutionsFAQ/>} /> 
                            <Route path="/diversidad" element={<Diversidad/>} />
                            <Route path="/diversidad/:id" element={<DiversidadId/>} />
                            <Route path="/calendario-oficial" element={<Calendario/>} />
                            
                            <Route element={<Error404/>} />                
            </Routes>
            <Footer/>
      </Router>
    )
  }
}


export default (App)


